import ufeApi from 'services/api/ufeApi';
import cookieUtils from 'utils/Cookies';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Update+BI+Account+API

function updateBiAccount(input, isOrderConfirmation) {
    let url = '/api/bi/account';
    const { enableProfileAccountGroup = false } = Sephora.configurationSettings;

    if (enableProfileAccountGroup && cookieUtils.isRCPAccountAPIEnabled()) {
        url = '/gway/v2/bi/account';
    }

    const typeQueryString = isOrderConfirmation ? '?type=orderConfirmation' : null;

    if (typeQueryString) {
        url = `${url}${typeQueryString}`;
    }

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify(input)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default updateBiAccount;
